import { Pagination } from './pagination';

export class Template {
    id = 0;
    name = '';
    text = '';
}

export class TemplateResponse {
    message = '';
    pagination = new Pagination();
    template = new Template;
    templates: Template[];
}
